/*
* Authenticate
*
* Display, update information of SubAccount
**/
import { MUAPP } from "account/api";

/**
 * authHandler
 * 
 * 
 */
export const logoutHandler = () => {
  MUAPP.cookies.deleteCookie("accessKey");
  MUAPP.cache.flushCookie();
}

export const logoutEventHandler = () => {
  if(!$(`.js-flush-cookie`)) return false;
  $(`.js-flush-cookie`).on("click", logoutHandler);
}


// WEBPACK FOOTER //
// ./src/scripts/src/account/auth.js